
import React from 'react';
import { Button } from '@/components/ui/button';

const CTA = () => {
  const phoneNumber = "6147728925";
  
  const handleCallAction = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = `tel:${phoneNumber}`;
  };

  return (
    <section className="py-16 relative overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('/lovable-uploads/0c1fef6f-0e6c-4a5c-bbb9-881166c5495d.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.85
        }}
      />
      
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900/80 to-navy/80 backdrop-blur-[2px] z-10"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-20">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Looking for a <span className="text-gold">Personalized Home Care</span> Experience?
          </h2>
          
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            Let Gold Standard Cleaning Group create a personalized cleaning experience designed to honor your lifestyle and your home's unique beauty.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" 
              className="bg-gold hover:bg-gold/90 text-navy font-medium px-8 shadow-lg hover:shadow-xl transition-all"
              onClick={handleCallAction}>
              Begin Your Custom Plan
            </Button>
            <Button size="lg" variant="outline" 
              className="border-white text-white hover:bg-white/10 px-8 backdrop-blur-sm bg-transparent"
              onClick={handleCallAction}>
              Speak with Our Concierge
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
